/**
 * Generates CSS for the embedded survey layout.
 * The survey is rendered inline within a container element on the host page.
 *
 * @param {object} style - The survey style configuration object.
 * @returns {string} CSS string for embedded layout.
 */
export function layoutEmbedCSS(style) {
    const widthValue = style.widthValue ?? 390;
    const widthUnit = style.widthUnit ?? 'px';
    const heightValue = style.heightUnit === 'auto' ? 'auto' : style.heightValue ?? 'auto';
    const heightUnit = style.heightUnit === 'auto' ? '' :  style.heightUnit ?? '';

    const position = style.position || 'middle';
    const isCenter = position === 'middle' || position === 'center';
    const isRight = position === 'right';

    const justifyVal = isRight ? 'flex-end' : (isCenter ? 'center' : 'flex-start');
    const marginVal = isRight ? '0 0 0 auto' : (isCenter ? '0 auto' : '0 auto 0 0');

    /* Mobile position helpers */
    const mobileRight = isRight || isCenter ? '0' : 'auto';
    const mobileLeft = !isRight || isCenter ? '0' : 'auto';

    return `
    /* ===== Embedded survey wrapper ===== */
    .ph-wrapper {
        width: 100%;
        display: flex;
        justify-content: ${justifyVal};
    }

    /* ===== Embedded survey box ===== */
    .ph-survey {
        width: ${widthValue}${widthUnit};
        max-width: 100%;
        height: ${heightValue}${heightUnit};
        display: flex;
        flex-direction: column;
        margin: ${marginVal};
        --ph-options-max-height: 100%;
        background-color: var(--ph-bg-color);
        padding: 16px;
        border-radius: 8px;
        font-family: var(--ph-font-family);
        line-height: normal;
        box-sizing: border-box;
        background: var(--ph-bg-color);
        box-shadow: none !important;
    }

    /* ===== Mobile responsive ===== */
    @media (max-width: 440px) {
        .ph-survey {
            border-radius: 16px 16px 0 0;
            width: 100%;
            margin: 0;
            bottom: 0;
            right: ${mobileRight};
            left: ${mobileLeft};
        }
    }`;
}
